import { axiosInstance as axios } from '../lib/axios';
import Config from '../config/environments';
import { POST_CHECKOUT } from '../actionTypes/checkout';
import { LIST_RESUME } from '../actionTypes/resume';
import { viewModelToModel } from '../mapper/checkout';
import { viewModelToModel as resumeViewModelToModel } from '../mapper/resume';
import updateState from './common/common';

export const postDataCheckout = (data, token, deviceData) => async (dispatch) => {
  const base = {
    type: POST_CHECKOUT,
    payload: {},
    state: true,
    success: true,
  };

  const url = `${Config.CHECKOUT.URL}/${token}${Config.CHECKOUT.PAY}`;

  const config = {
    headers: {
      'x-device-data': deviceData,
    },
  };

  dispatch(base);

  try {
    const response = await axios.post(url, data, config);
    base.payload = updateState(response);

    if (base.payload.success) {
      base.payload.data = viewModelToModel(base.payload.data);

      const resumeAction = {
        type: LIST_RESUME,
        payload: {
          state: false,
          data: resumeViewModelToModel(response.data),
          success: true,
        },
      };
      dispatch(resumeAction);
    }
  } catch (error) {
    base.payload = {
      state: false,
      data: null,
      success: false,
    };
  } finally {
    dispatch(base);
  }
};

export const postDataCheckout2 = (data, token) => async (dispatch) => {
  const base = {
    type: POST_CHECKOUT,
    payload: {},
    state: true,
    success: true,
  };

  const url = `${Config.CHECKOUT.URL}/${token}${Config.CHECKOUT.PAY}`;

  axios.post(url, data).then((response) => {
    base.payload = updateState(response);
    base.payload.data = viewModelToModel(base.payload.data);

    const resumeAction = {
      type: LIST_RESUME,
      payload: {
        state: false,
        data: resumeViewModelToModel(response.data),
        success: true,
      },
    };
    dispatch(resumeAction);
  }).catch((error) => {
    base.payload = (error);
  }).finally(() => {
    dispatch(base);
  });

  dispatch(base);
};
